module.exports = __webpack_public_path__ + "static/media/SF-3.4f5216b5.mp3";